import QuantitySelector from "./QuantitySelector";

const TicketList = ({ event }) => {
  return (
    <div className="ticket-list">
      {event.tickets.map((item) => {
        const currentQuantity = event.tickets.find((x) => x.type === item.name).num;
        return (
          <div key={item.id} className="ticket-list__item">
            <div className="ticket-list__item-details">
              <div className="ticket-list__item-details-title">{item.name}</div>
              <div className="ticket-list__item-details-description">{item.description}</div>
            </div>
            <div className="ticket-list__item-price">
              {item.price === 0 && `FREE`}
              {item.price > 0 && `A\$${item.price.toFixed(2)}`}
            </div>
            <div className="ticket-list__item-quantity">
              <QuantitySelector ticketID={item.id} min={0} current={currentQuantity} max={99} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TicketList;
